import React from 'react';
import { MOBILE_COLORS, MOBILE_BORDERS, MOBILE_ANIMATIONS } from '../../styles/mobileTheme';

const MobileButton = ({
  children,
  variant = 'primary', // primary, secondary, success, danger, ghost
  size = 'md', // sm, md, lg
  fullWidth = false,
  disabled = false,
  loading = false,
  icon,
  onClick,
  style = {},
  ...props
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'success':
        return {
          background: MOBILE_COLORS.gradientSuccess,
          color: '#ffffff',
          border: 'none',
        };
      case 'danger':
        return {
          background: MOBILE_COLORS.gradientDanger,
          color: '#ffffff',
          border: 'none',
        };
      case 'secondary':
        return {
          backgroundColor: MOBILE_COLORS.backgroundSecondary,
          color: MOBILE_COLORS.textPrimary,
          border: `1px solid ${MOBILE_COLORS.border}`,
        };
      case 'ghost':
        return {
          backgroundColor: 'transparent',
          color: MOBILE_COLORS.textPrimary,
          border: 'none',
        };
      case 'primary':
      default:
        return {
          background: MOBILE_COLORS.gradientPrimary,
          color: '#0b0e11',
          border: 'none',
        };
    }
  };

  const getSizeStyles = () => {
    switch (size) {
      case 'sm':
        return { padding: '10px 16px', fontSize: '13px' };
      case 'lg':
        return { padding: '16px 24px', fontSize: '16px' };
      case 'md':
      default:
        return { padding: '14px 20px', fontSize: '15px' };
    }
  };

  const baseStyles = {
    borderRadius: MOBILE_BORDERS.radius.md,
    fontWeight: '700',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: MOBILE_ANIMATIONS.fast,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: fullWidth ? '100%' : 'auto',
    opacity: disabled ? 0.5 : 1,
    outline: 'none',
    WebkitTapHighlightColor: 'transparent',
    touchAction: 'manipulation',
    ...getVariantStyles(),
    ...getSizeStyles(),
    ...style,
  };

  return (
    <button
      style={baseStyles}
      onClick={disabled || loading ? undefined : onClick}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span style={{ 
          width: '18px', 
          height: '18px', 
          border: '2px solid currentColor',
          borderTopColor: 'transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }} />
      ) : (
        <>
          {icon && icon}
          {children}
        </>
      )}
    </button>
  );
};

export default MobileButton;
